import BreadCrumb from "components/common/BreadCrumb";
import { Card, CardBody, CardHeader, Container } from "reactstrap";
import { ClientAdvanceSettlementTable } from "./ClientAdvanceSettlementTable";
import { getDocumentTitle } from "utils/helpers";

const ClientAdvanceSettlementList = () => {
  document.title = getDocumentTitle("Client Advance Settlements");
  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Client Advance Settlements" pageTitle="Finance" />
        <Card>
          <CardHeader>
            <h5 className="card-title mb-0">Settlement List</h5>
          </CardHeader>
          <CardBody>
            <ClientAdvanceSettlementTable />
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default ClientAdvanceSettlementList;
